export default __webpack_public_path__ + "static/media/2010.f975f6cf.png";